import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./bio-section.styles.css";

const BioSection = () => {
  const [copied, setCopied] = useState(false);
  const email = "pankajvyas033@gmail.com";

  const copyEmail = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="me-section top-200">
      <div className="me-h3-wrapper">
        <p className="h3">
          I'm a software engineer based in Bangalore. I build distributed systems, cloud-native platforms, and developer tools — I care just as much about reliability as I do about clean architecture. I'm a total detail freak: always asking why, always delivering quality.
        </p>
      </div>
    </section>
  );
};

export default BioSection;
